import { Box, Button, LinearProgress, Typography } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { colors } from '../theme'

interface Props {
  title: string
  description: string
  currentCount: number
  limit: number
  ctaLabel: string
}

export const OfferUsageLimitBanner: FC<Props> = ({ title, description, currentCount, limit, ctaLabel }) => {
  const navigate = useNavigate()
  const progressPercentage = Math.min((currentCount / limit) * 100, 100)

  return (
    <Box
      sx={{
        mb: 2,
        borderRadius: 3,
        border: '1px solid #F1D28B',
        backgroundColor: '#FFF8EA',
        p: { xs: 1.5, sm: 2 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'stretch', md: 'flex-start' },
          justifyContent: 'space-between',
          gap: 1.5,
        }}
      >
        <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
          <Typography sx={{ color: colors.cello, fontSize: '0.98rem', fontWeight: 800 }}>{title}</Typography>
          <Typography sx={{ mt: 0.5, color: '#5D6785', fontSize: '0.92rem', lineHeight: 1.4 }}>
            {description}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={() => navigate('/association?tab=functionalities')}
          sx={{
            alignSelf: { xs: 'stretch', md: 'flex-start' },
            flexShrink: 0,
            minWidth: { xs: '100%', md: 280 },
            borderRadius: '999px',
            textTransform: 'none',
            fontWeight: 800,
            color: colors.cello,
            borderColor: '#BFD0EE',
            whiteSpace: 'nowrap',
          }}
        >
          {ctaLabel}
        </Button>
      </Box>
      <Box sx={{ mt: 1.5 }}>
        <Typography sx={{ mb: 0.6, color: '#7A8197', fontSize: '0.86rem', fontWeight: 700 }}>
          {`${currentCount}/${limit}`}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          sx={{
            height: 8,
            borderRadius: '999px',
            backgroundColor: '#F6E7BF',
            '& .MuiLinearProgress-bar': {
              borderRadius: '999px',
              backgroundColor: '#D39A12',
            },
          }}
        />
      </Box>
    </Box>
  )
}
